import type { HueName } from '@habishine/client-core';

/** The CSS variable for one facet of a hue — `c` ring/glyph, `t` tile fill,
   `k` the saturated fill under white text. */
export function hueVar(hue: HueName, facet: 'c' | 't' | 'k'): string {
  return `var(--hue-${hue}-${facet})`;
}
